



















































import Vue, { PropType } from "vue";
import { mapGetters } from "vuex";
// import IconMyAccount from "@/assets/icons/IconMyAccount.vue";

export default Vue.extend({
  name: "HeaderMagicLink",
  components: {},
  props: {
    email: {
      type: String,
      default: ""
    },
    customers: {
      type: Array as PropType<Array<Record<string, unknown>>>,
      default: [] as Array<Record<string, unknown>>
    },
    expire: {
      type: String,
      default: null
    },
    hash: {
      type: String,
      default: null
    },
    token: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: "loading"
    }
  },
  computed: {
    ...mapGetters(["GET_CSRF_INFORMATION"]),
    isLoading(): boolean {
      return this.status === "loading";
    }
  },
  methods: {
    getCustomersName(customers: Array<Record<string, unknown>>) {
      const customer = customers.map(customer => customer.name);
      return customer[0] || " ";
    }
  }
});
